import React from "react";
import PropTypes from "prop-types";

import CiteThisQuoteModal from "./CiteThisQuoteModal";

export default class CiteThisQuoteBtn extends React.Component {
  static propTypes = {
    url: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false
    };
  }

  renderCiteThisQuoteModal() {
    if (!this.state.modalVisible) {
      return null;
    }

    return (
      <CiteThisQuoteModal
        onHidden={() => this.setState({ modalVisible: false })}
        url={this.props.url}
      />
    );
  }

  render() {
    return (
      <>
        <button
          className="btn btn-sm btn-primary cite-this-quote"
          onClick={() => this.setState({ modalVisible: true })}
          type="button"
        >
          Cite<span className="tw-hidden sm:tw-inline"> this Quote</span>
        </button>
        {this.renderCiteThisQuoteModal()}
      </>
    );
  }
}
